<template>
  <div class="container">
    <div class="head">
        <div class="title">
          <div class="text">游客体验满意度</div>
          <div class="toureindex">
            <div class="branch" v-if=" assessDesc.deduction">-{{assessDesc.deduction}}</div>
            <!-- 没有扣分记录 -->
            <div v-else class="no-de">未扣分</div>
            <div class="midlscore">{{ assessDesc.score ? assessDesc.score : allScore }}/{{ allScore }}</div>
          </div>
        </div>
        <div class="tip">
          <!-- <div class="con">{{assessDesc.areaName}}</div> -->
          <!-- <div class="con">{{assessDesc.areaType=='1'?'一':'二'}}类地区</div> -->
        </div>
        <div class="date">{{assessDesc.areaName}} {{assessDesc.quarterCN}}</div>
      </div>
    <div class="pg-pd12">
      <!-- <causeDeduction  :causeContent="assessDesc.deductionReason||''" causeTitle="扣分原因"></causeDeduction> -->
      <div class="cus-tour-content">
          <div class="tour-title">问卷情况</div>
          <div class="toure-content">
              <div class="left-tour-content">
                 <div class="zhdf-score">综合得分(分)</div>
                 <div class="df-score">{{ assessDesc.score }}</div>
              </div>
              <div class="left-tour-content">
                <div class="zhdf-score">问卷量(份)</div>
                 <div class="df-score">{{ assessDesc.questionnaireNum}}</div>
              </div>
          </div>
      </div>
   </div>
  </div>
</template>
<script>
    import causeDeduction from '../../components/causeDeduction';// 扣分原因
    import api from '../../../../service/modules/appraiseNew';

    export default {
        components: {
            causeDeduction
        },

        data () {
            return {
                assessDesc: {},
                // 相关材料列表
                assessFile: [
                    { fileName: '文化和旅游', fileType: 'pdf', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'doc', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'exl', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' }
                ],
                causeContent: '暂无',
                allScore: "10.0",
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 详情
            async touristExperience() {
              const { year, quarter, area} = this.$route.query;
              let params = {
                year,
                quarter,
                area
              }
              let res = await api.touristExperience(params);
              if(res.ret === 0) {
                this.assessDesc = res.data;
              }
            },
        },

        mounted () {
        },

        created () {
          this.touristExperience();
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }
        .head{
          width: 100%;
          background: #fff;
          padding: 24px 12px;
          margin-bottom: 24px;
          .title{
            height:22px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text{
              font-size:20px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .branch{
              height:22px;
              font-size:22px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,77,77,1);
              line-height:22px;
            }
        }
        .tip{
          margin-top:12px;
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(54,179,116,1);
          .con{
            border:1Px solid rgba(54,179,116,1);
            padding: 2px 4px;
            margin-right:14px;
          }
        }
        .date{
          margin-top:12px;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:12px;
        }
    }

  }
  .no-de {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999;
        line-height: 22px;
        width: 88px;
        text-align: right;
        margin-top: 3px;
      }
  .cus-tour-content{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    .tour-title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:20px;
    }
    .toure-content{
      margin-top:12px;
      height: 100px;
      background: #FFFFFF;
      box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
      border-radius: 3px;
      border: 1px solid #E9E9E9;
      display: flex;
      position: relative;
      .left-tour-content{
        width: 50%;
        
        .zhdf-score{   
          width: 100%;
          font-size: 12px;
          text-align: center;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 12px;
          margin-top: 24px;
          margin-bottom: 8px;
        }
        .df-score{ 
          width: 100%;
          text-align: center;
          font-size: 32px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #36B374;
          line-height: 32px;
        }
      }
      .right-tour-content{
        width: 50%;
      }
    }
    .toure-content::after{
        content: "";
        position: absolute;
        height: 100%;
        width: 1px;
        background-color: #eeeeee;
        top: 0;
        left: 50%;
        transform: scaleX(0.5);
      }
  }
  .toureindex{
    text-align: right;
    margin-top: 20px;
  }
  .midlscore{
    font-size: 14px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        line-height: 22px;
        margin-top: 2px;
  }
</style>
